import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './i18n'
import 'semantic-ui-css/semantic.min.css'
import './index.css'
import './mfr-a.css'
import './animations.css'
import "./analytics.js"

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
)




// WEBPACK FOOTER //
// ./src/index.js